import { css } from '@emotion/react'

import Colours from '@thebeansgroup/ui_style_helpers/colours'

export const content = css`
  padding-top: 16px;
  text-align: left;
`

export const button = (open) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 0;
  border-top: 1px solid ${Colours('grey', 200)};
  border-bottom: ${open ? `1px solid ${Colours('grey', 200)}` : 'none'};
  border-radius: 0;
  color: ${Colours('grey', 500)};
`
